import { render } from "./LegalPrivacyPage.vue?vue&type=template&id=895bda38"
import script from "./LegalPrivacyPage.vue?vue&type=script&lang=js"
export * from "./LegalPrivacyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__